import { FileOutlined } from '@ant-design/icons';

export default function DriveFileLink({ url }) {
    if (!url) return <></>;

    return (
        <a
            href={url.startsWith('http') ? url : `https://${url}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                borderRadius: 6,
                textDecoration: 'none',
                color: '#333',
                background: '#fafafa',
            }}
        >
            <img
                src="https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_48dp.png"
                alt="Google Drive"
                style={{ width: 24, height: 24 }}
            />
        </a>
    );
}
